
// SVG Icon: bulb
export default { id: "terriajs-bulb" };
export const id = "terriajs-bulb";
export const name = "bulb";
